/* eslint-disable no-restricted-imports */
import { AppBar, Box, Button, Container, Grid, Toolbar, Typography } from '@material-ui/core';
import { ArrowBack, Settings } from '@material-ui/icons';

import BudgetObservations from './components/BudgetObservations';
import BudgetParts from './components/BudgetParts';
import ClientInfo from './components/ClientInfo';
import Observations from './components/Observations';
import PendingList from './components/PendingList';
import StatusControls from './components/StatusControls';
import { BudgetProvider, useBudget } from './context/BudgetContext';
import { useStyles } from './styles';

function BudgetContent() {
  const classes = useStyles();

  const { handleBackToPending, currentView, budget } = useBudget();

  if (currentView === 'pending') {
    return <PendingList />;
  }

  return (
    <div className={classes.root}>
      <AppBar position='static' className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Box className={classes.leftSection}>
            <Button
              startIcon={<ArrowBack />}
              onClick={handleBackToPending}
              color='primary'
              className={classes.backButton}
            >
              Voltar para pendências
            </Button>
            <Box className={classes.osTitle}>
              <Settings color='primary' />
              <Typography variant='h5' style={{ fontWeight: 700 }}>
                OS #{budget?.serviceOrder || ''} / {budget?.jobOrder || ''}
              </Typography>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <Container maxWidth='xl' className={classes.container}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={8}>
            <Box marginBottom={3}>
              <ClientInfo />
            </Box>

            <Box marginBottom={3}>
              <BudgetParts />
            </Box>
          </Grid>

          <Grid item xs={12} lg={4}>
            <Box marginBottom={3}>
              <Observations />
            </Box>

            <Box marginBottom={3}>
              <BudgetObservations />
            </Box>

            <StatusControls />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default function Budget() {
  return (
    <BudgetProvider>
      <BudgetContent />
    </BudgetProvider>
  );
}
